<!--
    @Author : Luo
    @Time   : 2020/7/30 18:01
    @Note   : show message in all page
-->
<template>
  <div class="notice_container pos_fix flex_center" :style="{'top': top + 'px', 'opacity': opacity}" :class="type + '_notice'" v-if="visible">
    <div class="notice_info">
      <span>{{ content }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'notice',
  data () {
    return {
      visible: false,
      type: 'info',
      content: '',
      top: 20,
      opacity: 0,
      duration: 2000
    }
  },
  methods: {
    close: function () {
      let that = this
      // 延迟出现
      setTimeout(() => {
        that.opacity = 1
      }, 100)

      // 延迟消失
      setTimeout(() => {
        that.opacity = 0
      }, this.duration - 200)

      // 每减少一notice 通过减去高度达到往上推一格的效果，提前100毫秒
      setTimeout(() => {
        let tempLen = 0
        for (let item of document.body.children) {
          if (item.classList.value.indexOf('notice_container') > -1) {
            tempLen++
            // 最后一个不需要往上推
            if (tempLen > 1) item.style.top = Number(item.style.top.split('px')[0]) - 80 + 'px'
          }
        }
      }, this.duration - 50)

      // 销毁当前对象
      setTimeout(() => {
        that.visible = false
        this.$destroy(true)
        this.$el.parentNode.removeChild(that.$el)
      }, this.duration)
    }
  },
  mounted () {
    this.close()
  }
}
</script>

<style scoped>
.notice_container {pointer-events: none;min-width: 250px;box-shadow: 0 0 0 1px;border-radius: 6px;top: 80px;left: 50%;transform: translateX(-50%);padding: 20px 40px;z-index: 99;color: white;transition: all .5s;overflow: hidden}
.notice_info span {font-size: 14px;font-weight: bold}
.success_notice {background-color: rgba(240, 249, 235, 1);color: rgba(82, 162, 50, 1)}
.error_notice {background-color: rgba(254, 240, 240, 1);color: rgba(202, 93, 93, 1)}
.info_notice {background-color: rgba(253, 246, 236, 1);color: rgba(203, 140, 55, 1)}
</style>



// WEBPACK FOOTER //
// src/components/notice/index.vue